class CustomQuantity {
	constructor(el) {
		this.el = el;
		this.quantity = parseInt(el.getAttribute('data-quantity'), 10);
		this.singularName = el.getAttribute('data-singular-name');

		this.installListeners();
		this.updateQuantityText();
	}

	installListeners() {
		this.el.querySelector('.custom-quantity-minus').addEventListener('click', () => {
			this.setQuantity(this.quantity - 1);
		});

		this.el.querySelector('.custom-quantity-plus').addEventListener('click', () => {
			this.setQuantity(this.quantity + 1);
		});
	}

	setQuantity(quantity) {
		quantity = Math.max(1, Math.min(quantity, 25));

		if (quantity !== this.quantity) {
			this.quantity = quantity;
			this.el.setAttribute('data-quantity', this.quantity);
			this.updateQuantityText();
			this.dispatchEvent();
		}
	}

	dispatchEvent() {
		this.el.dispatchEvent(new CustomEvent('quantityChange', {
			detail: {
				quantity: this.quantity,
			},
		}));
	}

	updateQuantityText() {
		const textEl = this.el.querySelector('.custom-quantity-text');

		if (this.singularName === '') {
			textEl.textContent = this.quantity;
			return;
		}

		textEl.textContent = pluralize(this.singularName, this.quantity, true);
	}
}

window.CustomQuantity = CustomQuantity;

addEventListener('DOMContentLoaded', function () {
	const customQuantityEls = document.querySelectorAll('.custom-quantity');

	customQuantityEls.forEach((el) => {
		new CustomQuantity(el);
	});
});
